import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcPhone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.44 20.5q-2.827 0-5.68-1.314t-5.242-3.71q-2.389-2.393-3.704-5.241Q3.5 7.386 3.5 4.56A1.03 1.03 0 0 1 4.55 3.5h3.262q.378 0 .668.247.289.247.368.61L9.421 7.3q.06.41-.025.704-.084.293-.304.494l-2.31 2.248q.558 1.02 1.275 1.932.716.91 1.55 1.74a17.3 17.3 0 0 0 3.753 2.842l2.244-2.264q.235-.245.568-.342.334-.099.693-.048l2.777.565q.38.1.619.387.24.285.239.65v3.242q0 .45-.303.75t-.757.3M6.073 9.327l1.785-1.708a.18.18 0 0 0 .062-.106.23.23 0 0 0-.005-.125l-.434-2.234a.2.2 0 0 0-.068-.116A.2.2 0 0 0 7.288 5H5.15a.13.13 0 0 0-.096.038.13.13 0 0 0-.039.097 12.8 12.8 0 0 0 1.058 4.192m8.7 8.642q.994.464 2.074.709t2.018.291a.13.13 0 0 0 .135-.134V16.73a.2.2 0 0 0-.038-.125.2.2 0 0 0-.116-.068l-2.1-.427a.16.16 0 0 0-.1-.004.25.25 0 0 0-.092.062z"
  }));
}
var IcPhone = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPhone));

export { IcPhone as I };
